import Globals from "./globals";

export default class Analytics
{
	
	static VISIBILITY_THRESHOLD: number = 0.75;
	static observer: IntersectionObserver;
	
	static pushEvent(data: {[key:string]:any}){
		const datalayer = (window as any).dataLayer || [];
		//console.log("Analytics: ", data.event, data);
		datalayer.push(data);
		
	}
	
	static trackClick(clickUrl:string, clickLabel:string, isDownload: boolean = false)
	{
		try {
			Analytics.pushEvent({
				'event': isDownload ? 'downloads' : 'cta_interactions',
				'cd_click_text': clickLabel,
				'cd_click_destination_url': clickUrl,
			});
		} catch (e)
		{
		
		}
	}
	
	static trackSpotlight(spotlightHeader: string) {
		try {
			Analytics.pushEvent({
				'event': 'spotlight_engagement',
				'cd_click_text': spotlightHeader,
			});
		} catch (e) {
		
		}
	}
	
	static trackScrolledToSection(section: string)
	{
		try {
			Analytics.pushEvent({
				'event': 'scroll_to_page_section',
				'page_section_name': section
			});
		} catch (e) {
		
		}
	}
	
	static addTrackingToAllLinksOnPage()
	{
		const links = document.body.querySelectorAll('a[data-event-label]');
		for (let i = 0; i < links.length; i++)
		{
			const e = links[i] as HTMLElement;
			
			const trackType = e.dataset['eventType'] || 'click';
			const trackUrl = e.getAttribute('href');
			const trackLabel = e.dataset['eventLabel'];
			e.addEventListener('click', (e) => {
				Analytics.trackClick(trackUrl, trackLabel, trackType == 'download');
			});
		}
		
		
		if ('IntersectionObserver' in window &&
			'IntersectionObserverEntry' in window &&
			'intersectionRatio' in window.IntersectionObserverEntry.prototype)
		{
			Analytics.observer = new IntersectionObserver(
				Analytics.onScrollTagIntersection.bind(this),
				{
					threshold: Analytics.VISIBILITY_THRESHOLD,
				}
			);
		}
		else
		{
			console.warn("IntersectionObservers are not supported on this browser. Analytics will not track scrolls.");
		}
		
		const scrollTags = document.body.querySelectorAll('a[data-scroll-label]');
		for (let i = 0; i < scrollTags.length; i++)
		{
			Analytics.observer.observe(scrollTags[i]);
		}
	}
	
	static onScrollTagIntersection(entries: IntersectionObserverEntry[], observer: IntersectionObserver)
	{
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				
				Analytics.trackScrolledToSection((entry.target as HTMLElement).dataset.scrollLabel);
				
				observer.unobserve(entry.target);
			}
		});
	}
	
}
